var React = require('react');

function ArrowLeft (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M22.24 21.221c-.19 0-.38-.07-.53-.22l-3.49-3.47a.75.75 0 010-1.06l3.49-3.47c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06l-2.95 2.94 2.95 2.94c.29.29.29.77 0 1.06a.71.71 0 01-.53.22z","opacity":".75","key":0}),React.createElement("path",{"d":"M15.24 21.221c-.19 0-.38-.07-.53-.22l-3.49-3.47a.75.75 0 010-1.06l3.49-3.47c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06l-2.95 2.94 2.95 2.94c.29.29.29.77 0 1.06a.71.71 0 01-.53.22z","key":1})]);
}

ArrowLeft.defaultProps = {"viewBox":"0 0 34 34","preserveAspectRatio":"xMidYMid meet"};

module.exports = ArrowLeft;

ArrowLeft.default = ArrowLeft;
